var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReconciliationAct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_886)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3397 19.9514L12.1397 20.8188H3.15664C2.52022 20.8188 2 20.2984 2 19.6622V4.0478L2.00009 3.18034V1.15623C2.00009 0.52009 2.52031 -0.000408173 3.15673 -0.000408173H12.9878C13.6236 -0.000408173 14.5235 0.356403 14.9864 0.792152L18.2175 3.83349C18.681 4.26924 19.0597 5.14655 19.0597 5.78269L19.0598 15.1789L18.1923 14.3789L18.1922 5.78278C18.1922 5.69691 18.1765 5.59744 18.1529 5.49366H14.8672C13.9896 5.49192 13.2786 4.78088 13.2768 3.90329V0.902168C13.1736 0.88131 13.0741 0.867199 12.9877 0.867199H3.15664C2.99961 0.867199 2.86751 0.999573 2.86751 1.15627V19.6623C2.86751 19.819 2.99966 19.9514 3.15664 19.9514H11.3397ZM14.3919 1.42398L17.6229 4.46508C17.6694 4.50905 17.7154 4.56516 17.7602 4.6261H14.8672C14.6686 4.6261 14.4899 4.54576 14.3566 4.41361C14.2244 4.28063 14.1443 4.1019 14.1443 3.90324V1.24272C14.2395 1.30079 14.3257 1.36178 14.3919 1.42398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1582 22.7173C18.6759 22.7173 20.7169 20.6764 20.7169 18.1587C20.7169 15.6411 18.6759 13.6001 16.1582 13.6001C13.6406 13.6001 11.5996 15.6411 11.5996 18.1587C11.5996 20.6764 13.6406 22.7173 16.1582 22.7173Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7403 17.103L15.6309 19.2124L14.5762 18.1578",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.43373 16.769H12L12.3299 15.9016H6.43373C6.19406 15.9016 6 16.0956 6 16.3353C6 16.575 6.19402 16.769 6.43373 16.769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8192 10.9847H6.43373C6.19402 10.9847 6 10.7906 6 10.5509C6 10.3112 6.19406 10.1172 6.43373 10.1172H14.8192C15.0587 10.1172 15.253 10.3112 15.253 10.5509C15.253 10.7907 15.0587 10.9847 14.8192 10.9847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0602 8.09403H6.43373C6.19402 8.09403 6 7.90001 6 7.6603C6 7.42058 6.19402 7.22656 6.43373 7.22656H11.0602C11.2996 7.22656 11.4936 7.42058 11.4936 7.6603C11.4936 7.90001 11.2996 8.09403 11.0602 8.09403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0602 13.8793H6.43373C6.19402 13.8793 6 13.6853 6 13.4456C6 13.2059 6.19402 13.0119 6.43373 13.0119H11.0602C11.2996 13.0119 11.4936 13.2059 11.4936 13.4456C11.4936 13.6853 11.2996 13.8793 11.0602 13.8793Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24,
    fill: "white",
    transform: "matrix(1 0 0 -1 2 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReconciliationAct);
export default __webpack_public_path__ + "static/media/reconciliationAct.ac173356e91708dbf0ee3d2c1bcaf4ab.svg";
export { ForwardRef as ReactComponent };